import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ClienteService } from '../../cliente/cliente.service';
import { VehiculoService } from '../vehiculo.service';
import { ClienteCreateComponent } from '../../cliente/cliente-create/cliente-create.component';

@Component({
  selector: 'app-vehiculo-create',
  templateUrl: './vehiculo-create.component.html',
  styleUrls: ['./vehiculo-create.component.scss']
})
export class VehiculoCreateComponent implements OnInit {

  form: FormGroup = new FormGroup({});
  clientes: any[] = [];

  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public service: VehiculoService,
    public formatter: FormatterService,
    private clienteService: ClienteService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      patente: ['', [Validators.required]],
      marca: ['', [Validators.required]],
      modelo: ['', [Validators.required]],
      year: ['', [Validators.required]],
      unidad_medida: [0, [Validators.required]],
      usuario_id: [null],
    });

    this.getClientes();
  }

  agregarCliente(){
    const modalRef = this.modalService.open(ClienteCreateComponent, { size: 'lg', scrollable: true });
    modalRef.result.then((result: any) => {
      this.getClientes(true);
    }, (reason: any) => { });
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      this.service.insert(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert("Vehículo registrado con éxito.", "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro de vehículo.", "danger");
          if (err.error.msg) {
            this.alerts.addAlert(err.error.msg, "danger");
          }
          if (err.error.errors[0]) {
            this.alerts.addAlert(err.error.errors[0].msg, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  getClientes(setLastTipoAsActive: boolean = false): void {
    this.loading.show();
    this.clienteService.index_select().subscribe({
      next: (res) => {
        this.loading.hide();
        this.clientes = res;
        if (!this.form.value.usuario_id && this.form.value.usuario_id != 0 && this.clientes.length > 0) {
          if (setLastTipoAsActive) this.form.patchValue({ usuario_id: this.clientes[this.clientes.length - 1].id });
        }
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo obtener la lista de clientes.", "danger");
        if (err.error.msg) {
          this.alerts.addAlert(err.error.msg, "danger");
        }
        if (err.error.errors[0]) {
          this.alerts.addAlert(err.error.errors[0].msg, "danger");
        }
      }
    });
  }

  searchFn(term: any, item: any) {
    const removeAccents = (str: string) => {
      return str.normalize("NFD").replace(/[̀-ͯ]/g, "");
    }
    let terms = removeAccents(term.toLowerCase()).split(' ');
    let result = true;
    let p = removeAccents(([item.nombre].join(' ')).toLowerCase());
    terms.forEach(t => {
      result = result && p.includes(t);
    });
    return result;
  }
}
